
<div class="forbidden-container">
  <div class="forbidden-card">

    <h1 class="forbidden-code">403</h1>
    <h2 class="forbidden-title">Access Denied</h2>

    <p class="forbidden-message">
      You don’t have permission to view this page.
    </p>

    <p class="forbidden-hint">
      If you believe this is a mistake, please contact your administrator
      or return to a page you are authorized to access.
    </p>

    <div class="forbidden-actions">
      <a routerLink="/" class="btn-primary">
        Go to Home
      </a>

      <a routerLink="/about" class="btn-secondary">
        Learn More
      </a>
    </div>

  </div>
</div>
